import PropTypes from "prop-types"
import React, { useContext } from "react"

import { SignContractWizardContext } from "../../SignContractWizardContext"
import { isSignedPhase } from "../../signedPhase"
import DocusealSigningForm from "../DocusealSigningForm"
import SubmitAgreement from "./SubmitAgreement"

const SignAgreement = ({ isSubmitting }) => {
  const { state } = useContext(SignContractWizardContext)

  return isSignedPhase(state) ? (
    <SubmitAgreement isSubmitting={isSubmitting} />
  ) : (
    <DocusealSigningForm />
  )
}

SignAgreement.propTypes = {
  isSubmitting: PropTypes.bool,
}

export default SignAgreement
